export const datePickerStyle = {
	wrapper: {
		width: '100%',
		position: 'relative' as any,

		'& .MuiButtonBase-root': {
			padding: '12px',
		},
	},

	picker: {
		'& input': {
			order: 2,
		},
	},

	pickerActive: {
		'& .MuiInputBase-root .MuiInputBase-input, .MuiInputBase-root .MuiInputBase-input::placeholder': {
			opacity: 1,
			color: 'var(--primary-500)',
		},
	},

	pickerValid: {
		'&:hover,	&:focus': {
			'& .MuiInputBase-root .MuiInputBase-input': {
				color: 'var(--primary-500)',

				'&::placeholder': {
					opacity: 1,
					color: 'var(--primary-500)',
				},
			},
		},

		'& input:focus': {
			color: 'var(--primary-500)',
		},

		'& .MuiInputBase-root:hover:not(.Mui-disabled) .MuiOutlinedInput-notchedOutline': {
			border: '1px solid var(--primary-500) !important',
			borderRadius: '8px',
		},
	},

	iconError: {
		'& path': {
			fill: 'var(--error-500)',
		},
	},

	iconDisabled: {
		'& path': {
			fill: 'var(--neutral-200)',
		},
	},
};
